import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_PROGRESS_BAR_DATA
    SET_VISITED_STATE
`,
    {
        prefix: "leadprogressbar/"
    }
);
